import React, { useEffect } from 'react';
import { Seo } from './seo/Seo';
import { Link, Navigate, Route, Routes } from 'react-router-dom';
import { AboutPage } from './components/AboutPage';
import { BlogPage } from './components/BlogPage';
import { CareersPage } from './components/CareersPage';
import { CookiePolicyPage } from './components/CookiePolicyPage';
import { LandingPage } from './components/LandingPage';
import { PageLayout } from './components/PageLayout';
import { PrivacyPolicyPage } from './components/PrivacyPolicyPage';
import { TermsOfServicePage } from './components/TermsOfServicePage';
import { AIDisclosurePage } from './components/AIDisclosurePage';

function KairosRedirect() {
	useEffect(() => {
		window.location.replace('https://kairos.cognixisai.com');
	}, []);

	return <div className="min-h-screen bg-[#11120f] text-[#f2efe6] grid place-items-center">Opening Kairos…</div>;
}

export default function App() {
	return (
		<>
        <Seo />
        <Routes>
			<Route path="/" element={<LandingPage />} />
			<Route path="/about" element={<PageLayout><AboutPage /></PageLayout>} />
			<Route path="/careers" element={<PageLayout><CareersPage /></PageLayout>} />
			<Route path="/blog" element={<PageLayout><BlogPage /></PageLayout>} />
			<Route path="/privacy-policy" element={<PageLayout><PrivacyPolicyPage /></PageLayout>} />
			<Route path="/terms-of-service" element={<PageLayout><TermsOfServicePage /></PageLayout>} />
			<Route path="/cookie-policy" element={<PageLayout><CookiePolicyPage /></PageLayout>} />
			<Route path="/ai-disclosure" element={<PageLayout><AIDisclosurePage /></PageLayout>} />
			<Route path="/ai-assistant" element={<Navigate to="/#lab" replace />} />
			<Route path="/data-analytics" element={<Navigate to="/#lab" replace />} />
			<Route path="/kairos" element={<KairosRedirect />} />
			<Route path="*" element={<PageLayout><main className="editorial-page"><section className="editorial-section"><h1>Page not found</h1><p>This address does not match a page on Cognixis.</p><Link to="/">Return to Cognixis</Link></section></main></PageLayout>} />
		</Routes>
        </>
	);
}
